// The plant the user has chosen to work in, kept in this browser. Empty means every plant they may see.

const KEY = 'workingPlantId';

export const getWorkingPlantId = (): string => {
  try {
    return localStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
};

export const setWorkingPlantId = (plantId: string): void => {
  try {
    if (plantId) localStorage.setItem(KEY, plantId);
    else localStorage.removeItem(KEY);
  } catch {
    // Without storage the choice lasts until the page is reloaded
  }
};

// The lists and counts that can be narrowed to one plant
const PLANT_LISTS = /^\/(sales|purchase|manufacturing\/work-orders)\/(paginated|summary)$/;

export const takesPlantFilter = (method: string | undefined, url: string | undefined): boolean =>
  (method ?? 'get').toLowerCase() === 'get' && PLANT_LISTS.test((url ?? '').split('?')[0]);
